// extracted by mini-css-extract-plugin
export var checkbox = "_2k-0";
export var circle = "_2k-3";
export var horizontalContainer = "_2k-7";
export var sm = "_2k-5";
export var switch0 = "_2k-2";
export var switchDisabled = "_2k-8";
export var switchEnabled = "_2k-1";
export var textSwitchContainer = "_2k-9";
export var textSwitchOption = "_2k-a";
export var textSwitchOptionSelected = "_2k-b";
export var verticalContainer = "_2k-6";
export var xs = "_2k-4";